import React, { Component } from "react";
import block from "bem-cn-lite";
import FormHeader from "./Header";
import Header from "../CustomWorkflow/Header";
import { I18n } from "react-i18next";
import Input from "./Input/input";
import Textarea from "./Input/textarea";
import Select from "./Input/select";
import Button from "./Input/button";
import FormField from "./FormField";

import InfoTooltip from "../Components/InfoTooltip";
import StateBar from "../CustomWorkflow/Statebar";
import Controls from './Controls'

const b = block("RequestForms");

export default class RequestForms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            urgency: "",
            description: "",
            title: "",
            showResult: false,
            submitAttempt: false
        };
        this.tooltips = (t) => [
            t("requestForms:tooltips.1"),
            t("requestForms:tooltips.2"),
            t("requestForms:tooltips.3"),
        ];
    }
    handleSubmit(e) {
        const { urgency, title, description } = this.state;
        e.preventDefault();
        this.setState({ submitAttempt: true });
        if (urgency.length > 0 && description.length > 0 && title.length > 0)
            this.setState({ showResult: true });
    }
    handleChange(e) {
        this.setState({
            [e.name]: e.value
        });
    }
    render() {
        const {
            title,
            urgency,
            description,
            showResult,
            submitAttempt
        } = this.state;

        let activeTooltip = 0;
        switch (true) {
            case title === "":
                activeTooltip = 0;
                break;
            case urgency === "":
                activeTooltip = 1;
                break;
            case description === "":
                activeTooltip = 2;
                break;
            default:
                activeTooltip = -1;
                break;
        }
        return (
            <I18n ns={["requestForms"]}>
                {(t) => (
                    <div className={b()}>
                        <div
                            className={b('content')}
                            style={{
                                display: !showResult ? "block" : "none"
                            }}
                        >
                            {activeTooltip > -1 && (
                                <InfoTooltip text={this.tooltips(t)[activeTooltip]} />
                            )}
                            <FormHeader
                                name={t("requestForms:formTitle")}
                                description={t("requestForms:formDescription")}
                            />
                            <form
                                className={b("form-container")}
                                onSubmit={e => this.handleSubmit(e)}
                            >
                                <FormField
                                    label={ t("requestForms:requestTitle") + ": *" }
                                    blink={activeTooltip===0}
                                    invalid={
                                        title.length === 0 && submitAttempt
                                    }
                                >
                                    <Input
                                        name="title"
                                        value={title}
                                        invalid={ title.length === 0 && submitAttempt }
                                        onChange={e => this.handleChange(e)}
                                    />
                                </FormField>
                                <FormField
                                    invalid={!urgency && submitAttempt}
                                    blink={activeTooltip===1}
                                    label={ t("requestForms:requestUrgency") + ": *" }
                                >
                                    <Select
                                        onChange={e =>
                                            this.handleChange({
                                                name: "urgency",
                                                value: e.name
                                            })
                                        }
                                        placeholder={t( "requestForms:select.placeholder")}
                                        invalid={!urgency && submitAttempt}
                                        name="urgency"
                                        value={urgency}
                                        options={[
                                            {
                                                name: t(
                                                    "requestForms:select.values.high"
                                                ),
                                                value: "high"
                                            },
                                            {
                                                name: t(
                                                    "requestForms:select.values.medium"
                                                ),
                                                value: "medium"
                                            },
                                            {
                                                name: t(
                                                    "requestForms:select.values.low"
                                                ),
                                                value: "low"
                                            }
                                        ]}
                                    />
                                </FormField>
                                <FormField
                                    invalid={ description.length === 0 && submitAttempt }
                                    blink={activeTooltip===2}
                                    label={
                                        t("requestForms:requestDescription") +
                                        ": *"
                                    }
                                >
                                    <Textarea
                                        value={description}
                                        invalid={
                                            description.length === 0 &&
                                            submitAttempt
                                        }
                                        name="description"
                                        onChange={e => this.handleChange(e)}
                                    />
                                </FormField>
                                <Button>{t("global:submit")}</Button>
                            </form>
                        </div>
                        <div
                            style={{
                                display: showResult ? "block" : "none"
                            }}
                        >
                            <Header 
                                folders={[t("requestForms:folders.1"), t("requestForms:folders.2")]}
                                title={title} 
                            />
                                <InfoTooltip text={t("requestForms:doneTooltip")} />
                            <div
                                style={{
                                    borderBottom: "1px solid #f0f3f6",
                                    borderTop: "1px solid #f0f3f6"
                                }}
                            >
                                <StateBar
                                    currentStatus={3}
                                    initials={t("requestForms:initial")}
                                    assigneeName={t(
                                        "requestForms:assigneeName"
                                    )}
                                    avatarColor="#3d50ce"
                                    author={t(
                                        "requestForms:byYou"
                                    )}
                                    disabled={true}
                                />
                            </div>
                            <Controls
                                items={[{
                                    icon: 'Calendar',
                                    name: t('requestForms:setADate')
                                },{
                                    icon: 'Play',
                                    name: '0:00',
                                    chevron: true
                                },{
                                    icon: 'Subtask',
                                    name: t('requestForms:addSubtask'),
                                },{
                                    icon: 'Field',
                                    name: t('requestForms:1field'),
                                    chevron: true
                                },{
                                    icon: 'Attach',
                                },{
                                    icon: 'Dependency',
                                }, {
                                    icon: 'Sharing',
                                    name: '18'
                                }]}
                            />
                            <div className={b("description")}>
                                <p>
                                    <b>
                                        {t("requestForms:requestUrgency") + ":"}
                                    </b>
                                    <br />
                                    {urgency}
                                </p>

                                <p>
                                    <br />
                                    <br />
                                    <b>
                                        {t("requestForms:requestDescription") +
                                            ":"}
                                    </b>
                                    <br />
                                    <span
                                        style={{
                                            maxHeight: 204,
                                            overflow: "hidden",
                                            display: 'block'
                                        }}
                                    >
                                        {description.split("\n").map((item, index) => (
                                            <span key={index}>
                                                {item}
                                                <br />
                                            </span>
                                        ))}
                                    </span>
                                </p>
                            </div>
                            <Controls 
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    width: '100%'
                                }}
                                items={[{
                                    icon: 'Attach',
                                    name: t("requestForms:addComment")
                                },{
                                    icon: 'Smile',
                                }]}
                            />
                        </div>
                    </div>
                )}
            </I18n>
        );
    }
}
